export const isObject = <T>(value: T): value is T & object => {
	return value && typeof value === "object";
};

export const getDescriptor = (
	inertObject: object,
	p: string | symbol | number
) => {
	let object: object | undefined = inertObject;
	let descriptor =
		object &&
		object !== Object.prototype &&
		Reflect.getOwnPropertyDescriptor(object, p);
	while (object && object !== Object.prototype && !descriptor) {
		object = Reflect.getPrototypeOf(object) ?? undefined;
		descriptor = object && Reflect.getOwnPropertyDescriptor(object, p);
	}
	return object && object !== Object.prototype && descriptor
		? { object, descriptor }
		: { object: undefined, descriptor: undefined };
};

export const getAllGetterKeys = (inertObject: object): Set<string | symbol> => {
	let object: object | null = inertObject;
	const getterKeys = new Set<string | symbol>();
	while (object && object !== Object.prototype) {
		const keys = Reflect.ownKeys(object);
		for (const key of keys) {
			if (Reflect.getOwnPropertyDescriptor(object!, key)!.get) {
				getterKeys.add(key);
			}
		}
		object = Reflect.getPrototypeOf(object);
	}
	return getterKeys;
};
